/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bidbattle__Entry_PriceInputs */

const en_bidbattle__entry_price = /** @type {(inputs: Bidbattle__Entry_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entry price`)
};

/**
* | output |
* | --- |
* | "Entry price" |
*
* @param {Bidbattle__Entry_PriceInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const bidbattle__entry_price = /** @type {((inputs?: Bidbattle__Entry_PriceInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bidbattle__Entry_PriceInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_bidbattle__entry_price(inputs)
});